import { cubicEaseOut, transition } from '@helpers/animation';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
import HeadingStyles from '../Global/Typography/Heading.styles';
const Title = styled.h1 `
  display: inline-block;
  ${HeadingStyles.H4Styles}
  margin: 0;
  padding-bottom: ${fluid(6, 12)};

  &::after {
    ${transition('transform')};

    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    display: block;
    background-color: ${brand.primary.blue.base};
    transform: scaleX(0);
    transform-origin: left center;
  }

  &[data-line-after='false'] {
    position: relative;
  }

  &[data-line-after='false']::after {
    width: 80px;
    height: 4px;

    @media ${from(Device.TabletLarge)} {
      width: 52px;
    }
  }

  &[data-line-after='true']::after {
    transition-duration: 1s;
    width: 100%;
    height: ${fluid(2, 4)};
  }

  [data-active='true'] &::after {
    transform: scaleX(1);
  }

  &[data-line-after='true'] {
    @media ${from(Device.Tablet)} {
      ${transition('max-width')};

      display: inline-flex;
      flex: 1 1 100%;
      gap: 16px;
      max-width: 100%;

      &::after {
        position: relative;
        flex: 1 1 24px;
        bottom: 6px;
        margin-top: auto;
      }
    }
  }
`;
const Text = styled.span `
  opacity: 0;
  transition: opacity 0.3s ${cubicEaseOut} 0.15s, transform 0.3s ${cubicEaseOut} 0.15s;
  transform: translateY(16px);

  [data-active='true'] & {
    opacity: 1;
    transform: translateY(0);
  }
`;
const TitleBlockStyles = {
    Text,
    Title,
};
export default TitleBlockStyles;
